import React from 'react';
import { Button } from 'react-bootstrap';

import Table from '../../../../../facturotopia/table/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AportacionesODepositosList = ({ data = [], onEdit, onListChange }) => {

  const handleEdit = (item) => {
    onEdit(item);
  }

  const handleDelete = (item) => {
    const newData = data.filter((value) => item.id !== value.id);

    onListChange(newData);
  }

  return (
    <>
      <Table
        columns={ columns(handleEdit, handleDelete) }
        rowKey={ 'id' }
        data={ data }
      >
      </Table>
    </>
  );
}

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={ handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['far', 'edit'] } />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={ handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'trash'] } />
          </Button>
        </>
      );
    }
  },
  {
    align: 'center',
    key: 'TipoAportacionODepositoLabel',
    title: 'Tipo aportación o depósito',
    dataIndex: 'TipoAportacionODepositoLabel',
  },
  {
    align: 'right',
    key: 'MontAportODep',
    title: 'Monto aportación o depósito',
    dataIndex: 'MontAportODep',
  },
  {
    align: 'center',
    key: 'RFCFiduciaria',
    title: 'RFC Fiduciaria',
    dataIndex: 'RFCFiduciaria',
  },
];

export default AportacionesODepositosList;